export default __webpack_public_path__ + "static/media/Suites-RGB-sm.dd2c557a.webp";